import React, { createElement, useContext, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import TabStyleButton from "../../../../../Resusable/TabStyleButton";
import { globalContext } from "../../../../../context/ContextProvider";
import { buyerTableComponents } from "../../../../../helpers/auctionTable";
import AuctionFilter from "../../../../commanPage/searchAndFilter/AuctionFilter";
import AuctionSearch from "../../../../commanPage/searchAndFilter/AuctionSearch";

function AuctionStatus() {
  const { buyerFilterBtn, setBuyerFilterBtn } = useContext(globalContext);
  const isMobile = useMediaQuery({ query: "(max-width: 550px)" });
  const isDastop = useMediaQuery({ query: "(max-width: 1420px)" });
  const [auctionFilter, setAuctionFilter] = useState("");
  const [searchData, setSearchData] = useState("");

  useEffect(() => {
    setSearchData("");
  }, [buyerFilterBtn]);

  return (
    <div
      className={`cover ${isMobile ? "p-1" : ""} white flex column gap-1 `}
      style={{ padding: !isMobile && "0px 2rem 2rem 2rem" }}
    >
      <div
        className={`valign-wrapper ${isMobile ? "justify-center" : "space-between"
          } flex-wrap`}
      >
        <TabStyleButton
          buttonPosition={buyerFilterBtn}
          setButtonPosition={setBuyerFilterBtn}
        />
        <div className={`valign-wrapper gap-1 ${isMobile && "flex-wrap"}`}>
          <span
            className="input-field-style"
            style={{
              height: "40px", width: isMobile ? "100%" : "170px",
              marginBottom: !isMobile && isDastop && "1rem",
            }}
          >
            <AuctionFilter setAuctionFilter={setAuctionFilter} />
          </span>
          <div
            className="input-field-style "
            style={{
              height: "40px",
              width:isMobile?"100%": "200px",
              marginBottom: isDastop && "1rem",
            }}
          >
            <AuctionSearch
              searchData={searchData}
              setSearchData={setSearchData}
              placeholder={"Search"}
            />
          </div>
        </div>
      </div>

      {buyerTableComponents[buyerFilterBtn] &&
        createElement(buyerTableComponents[buyerFilterBtn], {
          searchTraderList: searchData,
          auctionFilter: auctionFilter,
        })}
    </div>
  );
}

export default AuctionStatus;
